<hlm-tabs tab="general">
  <div class="flex justify-between">
    <div class="px-sm pt-sm w-2/3">
      <div class="paragraph-large-semibold">Configuration de la séquence</div>
      <hlm-tabs-list>
        <button hlmTabsTrigger="general">
          Général
          @if (detailFormService.general.invalid && detailFormService.general.touched) {
            <div
              class="text-feedback-negative-main bg-feedback-negative-lightest p-xxs flex rounded-full"
              hlmTooltipTrigger="Il y a au moins une information manquante obligatoire dans cet onglet"
            >
              <ng-icon name="lucideCircleAlert" hlm size="sm" />
            </div>
          }
        </button>
        <button hlmTabsTrigger="objectifs">Objectifs</button>
        <button hlmTabsTrigger="livrables">{{ traductions().livrable | titlecase }}s</button>
        <button hlmTabsTrigger="activites">
          Activités
          @if (detailFormService.activites.hasError('required') && detailFormService.activites.touched) {
            <div
              class="text-feedback-negative-main bg-feedback-negative-lightest p-xxs flex rounded-full"
              hlmTooltipTrigger="Au moins une activité doit être liée"
            >
              <ng-icon name="lucideCircleAlert" hlm size="sm" />
            </div>
          }
        </button>
      </hlm-tabs-list>
    </div>
    <div class="mr-sm right-0 flex items-center gap-4">
      @if (form.enabled) {
        <ng-icon
          class="opacity-20"
          [class.opacity-100]="form.dirty"
          [name]="form.dirty ? 'lucideSave' : 'lucideCheckCheck'"
          [hlmTooltipTrigger]="
            form.dirty ? 'Les données ne sont pas encore sauvegardées' : 'Toutes les données sont sauvegardées'
          "
        />

        <button (click)="terminerSequence()" hlmBtn variant="secondary">Valider la séquence</button>
      }
    </div>
  </div>

  <div hlmTabsSeparator></div>
  <div class="p-lg h-full overflow-y-auto">
    <div class="gap-lg flex flex-col pt-0" hlmTabsContent="general">
      <app-detail-general [form]="detailFormService.general" [cartographie]="cartographie()" />
    </div>
    <div hlmTabsContent="objectifs">
      <app-detail-objectifs [referentiel]="referentiel()" [module]="module()" />
    </div>
    <div hlmTabsContent="livrables">
      <app-detail-livrables [form]="detailFormService.form" [referentiel]="referentiel()" [module]="module()" />
    </div>
    <div hlmTabsContent="activites">
      <app-activites [form]="detailFormService.form" [cartographie]="cartographie()" [sequence]="sequence()" />
    </div>
  </div>
</hlm-tabs>
